import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import {
  BooleanInput,
  FormWithRedirect,
  NumberInput,
  ReferenceInput,
  SelectInput,
  Toolbar,
  required,
} from "react-admin";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import CreatedByInput from "../../../../Components/ReferenceFields/CreatedBy/CreatedByInput";
import { SourceCustomer } from "../../Customer/Constant/Source";
import { SourceMelCategory } from "../../MelCategory/Constant/Source";

const MelCategoryCustomerEditForm = props => {
  return (
    <FormWithRedirect
      {...props}
      render={(formProps: any) => (
        <Card>
          <form>
            <CardContent>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={2}>
                  <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Creation Information
                    </Typography>
                    <BooleanInput label="Active/Passive" source="isActive" />
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <ReferenceInput
                        label="CUSTOMER NAME"
                        perPage={99999}
                        source="customerId"
                        reference={SourceCustomer}
                        translateChoice={false}
                        validate={required()}
                        disabled
                      >
                        <SelectInput optionText="customerName" optionValue="id" fullWidth />
                      </ReferenceInput>
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <ReferenceInput
                        label="CATEGORY NAME"
                        perPage={99999}
                        source="categoryId"
                        reference={SourceMelCategory}
                        translateChoice={false}
                        validate={required()}
                        disabled
                      >
                        <SelectInput optionText="categoryName" optionValue="id" fullWidth />
                      </ReferenceInput>
                    </Box>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CreatedByInput fullWidth disabled />
                    </Box>
                    <Box flex={1} ml={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="createdDate" label="CREATED DATE" fullWidth showTime disabled />
                    </Box>
                  </Box>
                  <Box mt="1em" />
                  <Typography variant="h6" gutterBottom color="primary">
                    Updatable Field
                  </Typography>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <NumberInput source="rddTimeInside" label="RDD TIME INSIDE" validate={required()} fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <NumberInput source="rddTimeOutside" label="RDD TIME OUTSIDE" validate={required()} fullWidth />
                    </Box>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <NumberInput source="successRate" label="SUCCESS " max={99} validate={required()} fullWidth />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={true}
              invalid={formProps.invalid}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
              resource="melcategorycustomers"
            />
          </form>
        </Card>
      )}
    />
  );
};

export default MelCategoryCustomerEditForm;
